import {
  Component, OnInit, Input, ViewChild, ContentChildren, QueryList,
  Output, EventEmitter, AfterContentInit, AfterViewInit, ViewChildren, ViewEncapsulation
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
//import { SabisGridComponent } from '../grid/grid.component';
//import { NgModel } from '@angular/forms';
//import { NgbModalConfig, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'sabis-ngx-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
  //encapsulation: ViewEncapsulation.None,
  //providers: [NgbModalConfig, NgbModal]
})
export class SabisNgxDialogComponent implements OnInit, AfterContentInit, AfterViewInit {
  @Input('scTitle') scTitle: string = '';
  @Input('scType') scType: 'notification' | 'alert' = 'notification';
  @Input('scShowHeaderCloseButton') scShowHeaderCloseButton: boolean = true;
  @Input('scClass') scClass: string = '';
  @Input('scCloseOnEsc') scCloseOnEsc: boolean = true;
  @Input('scCentered') scCentered: boolean = true;
  @Input('scMinimizable') scMinimizable: boolean = false;

  @Output('scModalHided') scModalHided = new EventEmitter<any>();

  ////@ViewChild('modal', { static: true }) modal;
  //@ViewChildren('footer') footer;
  //@ViewChild('content', { static: true }) content;

  //@ContentChildren(SabisGridComponent) _grids: QueryList<SabisGridComponent>;
  // TODO: should not be any references or mention to grid.
  // 1. It cause circle files dependency
  // 2. Architecture problems
  // Should at least create global on close event and handle it on upper (SDP) level or in sabis-components.module file
  //public isModelOpen: boolean = false;
  //private _loadedGrids: Array<SabisGridComponent> = [];
  //private _activeModal: NgbActiveModal;
  //@ContentChildren(NgModel) models: QueryList<NgModel>;

  public isMinimized: boolean = false;
  // private _config: NgbModalConfig, private modalService: NgbModal
  constructor(public dialogRef: MatDialogRef<SabisNgxDialogComponent>) { }

  ngOnInit() {
    // customize default values of modals used by this component tree
    //this._config.backdrop = 'static';
    // this._config.keyboard = this.scCloseOnEsc;
  }

  ngAfterViewInit() {
    //if (typeof this.scShowHeaderCloseButton === 'undefined') {
    //  this.scShowHeaderCloseButton = true;
    //}

    //if (typeof this.scCloseOnEsc === 'undefined') {
    //  this.scCloseOnEsc = true;
    //}
  }

  show() {
    //let dialogContent: SabisDialogComponent = this.content;
    //this._activeModal = this.modalService.open(dialogContent, {
    //  container: this.content.elementRef.nativeElement.parentElement,
    //  centered: this.scCentered,
    //  keyboard: this.scCloseOnEsc,
    //  backdrop: 'static'
    //});
    //if (this.footer && this.footer.nativeElement && this.footer.nativeElement.children) {
    //  this.footer.nativeElement.children[0].children[0].focus()
    //}
  }

  public minimize(): void {
    this.isMinimized = true;
    this.dialogRef.updatePosition({ bottom: '50px', right: '0px' });

    this.dialogRef['_ref'].overlayRef._backdropElement.style.setProperty('display', 'none');
  }

  public maximize(): void {
    this.isMinimized = false;
    this.dialogRef.updatePosition();

    this.dialogRef['_ref'].overlayRef._backdropElement.style.setProperty('display', 'inherit');
  }

  public hide(): void {
    //if (this._activeModal) {
    //  this._activeModal.close();
    //  // this.isModelOpen = false;
    //  this.onModalHide();
    //}
    this.dialogRef.close();
    this.onModalHide();
  }

  onModalHide() {
    //for (let i = 0; i < this._loadedGrids.length; i++) {
    //  this._loadedGrids[i].resetState();
    //}
    //// reset form models when hiding dialogs
    //this.models.toArray().forEach(m => {
    //  m.control.reset();
    //});

    //this.scModalHided.emit();
    //this.isModelOpen = false;
  }

  ngAfterContentInit(): void {
    //// store if the dialog has a grid in order to reset the state when hiding the dialog
    //this._grids.toArray().forEach((grid) => {
    //  this._loadedGrids.push(grid);
    //});
  }
}
